import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import CustomSwitchToggle from "../../../components/common/Switch";
import SelectField from "../../../newComponents/form-fields/SelectField";
import "./ManageAutoPayForm.css";

export interface ManageAutoPayFormProps {
  formId: string;
  onSubmit: (values: any) => void | Promise<void>;
  accountOptions: { Id: number; Name: string }[];
}

const ManageAutoPayForm: React.FC<ManageAutoPayFormProps> = ({
  formId,
  onSubmit,
  accountOptions,
}) => {
  const { control, handleSubmit } = useFormContext();

  return (
    <form
      id={formId}
      className="manage-auto-pay-form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <p className="manage-auto-pay-form__description">
        Auto Pay ensures uninterrupted service by automatically processing
        payments on time.
      </p>

      <div className="manage-auto-pay-form__toggle-group">
        <Controller
          name="isEnabled"
          control={control}
          render={({ field }) => (
            <CustomSwitchToggle
              label="Auto Pay Rent"
              checked={field.value === "true"}
              onClick={(e) => field.onChange(e.target.checked ? "true" : "false")}
            />
          )}
        />
      </div>

      <div className="manage-auto-pay-form__field">
        <SelectField
          name="accountId"
          label="Select Account"
          required
          requiredMessage="Please select an account"
          options={accountOptions}
          placeholderText="Select"
        />
      </div>

      {/* <div className="manage-auto-pay-form__row">
        <div className="manage-auto-pay-form__field">
          <InputField
            name="dayOfMonth"
            label="Select day of the month"
            type="number"
            required
            requiredMessage="Day is required"
            placeholder="Enter Day of the month"
          />
        </div>
        <div className="manage-auto-pay-form__field">
          <SelectField
            name="billingPeriodId"
            label="Billing Period"
            required
            requiredMessage="Billing period is required"
            options={billingPeriodOptions}
            placeholderText="Select Month"
          />
        </div>
      </div>

      <p className="manage-auto-pay-form__footer-note">
        Rent is due 1st of the month
      </p> */}
    </form>
  );
};

export default ManageAutoPayForm;
